import type { Block } from "@prismicio/types-internal/lib/content"
import type { Node as ProseMirrorNode, Schema } from "@tiptap/pm/model"

import { Paragraph } from "../../extensions"

export function mapTableCellToParagraph(
  schema: Schema,
  block: Block,
): ProseMirrorNode | undefined {
  switch (block.type) {
    case "hyperlink":
    case "paragraph":
    case "strong":
    case "em": {
      return Paragraph.converter.fromPrismic(schema)(block)
    }
    default: {
      return undefined
    }
  }
}

interface CreateButtonElementArgs {
  title: string
  className: string
  tabIndex?: number
  onMouseDown?: (event: MouseEvent, currentTarget: HTMLButtonElement) => void
  onClick: (event: MouseEvent, currentTarget: HTMLButtonElement) => void
  [key: `data-${string}`]: string | number | boolean
  [key: `aria-${string}`]: string | number | boolean
}

export function createButtonElement(args: CreateButtonElementArgs) {
  const { title, className, onClick, tabIndex, onMouseDown, ...dataProps } =
    args
  const button = document.createElement("button")
  button.className = className
  button.setAttribute("type", "button")
  button.setAttribute("title", title)
  button.setAttribute("aria-label", title)
  button.setAttribute("tabIndex", "0")

  if (onMouseDown) {
    button.addEventListener("mousedown", (event) => {
      const currentTarget = event.currentTarget as HTMLButtonElement
      onMouseDown(event, currentTarget)
    })
  }

  button.addEventListener("click", (event) => {
    const currentTarget = event.currentTarget as HTMLButtonElement
    onClick(event, currentTarget)
  })

  Object.entries(dataProps).forEach(([key, value]) => {
    button.setAttribute(key, value.toString())
  })

  return button
}

export function renderHtmlFromString(html: string) {
  const renderer = document.createElement("div")
  renderer.innerHTML = html
  if (!renderer.firstChild) return null
  return renderer.firstChild
}
